export default "__VITE_PUBLIC_ASSET__7a1d306a__"